<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="6">
          <v-select
            v-model="selectedClass"
            :items="classList"
            item-text="name"
            :return-object="true"
            item-value="_id"
            label="Lớp"
            outlined
            dense
          />
        </v-col>
        <v-col cols="12" md="3">
          <DateISOPickerMargin
            label="Từ ngày"
            :date.sync="start"
            outlined
            :rules="[$rules.emptyDate, $rules.dateFromNow]"
            dense
          />
        </v-col>
        <v-col cols="12" md="3">
          <DateISOPickerMargin
            label="Đến ngày"
            :date.sync="end"
            outlined
            :rules="[$rules.emptyDate, $rules.dateFromNow]"
            dense
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button mb-5" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import DateISOPickerMargin from '@/components/basic/picker/DateISOPickerMargin.vue'

export default {
  components: { DateISOPickerMargin },
  data() {
    return {
      selectedClass: null,
      start: moment().subtract(30, 'days').startOf('day').toISOString(),
      end: moment().toISOString(),
      classList: [],
    }
  },
  computed: {
    ...mapState('boardingClass', ['boardingClass']),
    isButtonDisabled() {
      return !this.selectedClass || Object.keys(this.selectedClass).length === 0
    },
  },
  mounted() {
    this.loadClassList()

    this.onFilterChanged()
  },
  methods: {
    ...mapActions('boardingClass', ['fetchBoardingClass']),

    async loadClassList() {
      try {
        await this.fetchBoardingClass()
        this.classList = this.boardingClass || []
      } catch (error) {
        console.error('Failed to load class list:', error)
      }
    },

    onFilterChanged() {
      const startTime = moment(this.start)
      const endTime = moment(this.end)
      const startOfDay = startTime.startOf('day').toISOString()
      const endOfDay = endTime.endOf('day').toISOString()

      const params = {
        date_gte: startOfDay,
        date_lte: endOfDay,
        class: this.selectedClass,
      }

      this.$emit('onFilterChanged', params, this.selectedClass)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
